<template>
  <v-container class="text-center">
    <img
      :src="require('@/assets/cox-spin.gif')"
      alt="Chargement en cours..."
      style="margin: auto"
    />
  </v-container>
</template>

<script>
export default {
  name: "AppSpinner",
};
</script>

<style></style>
